/**
 * Central policy for diagnostics that may be sent to an external error reporter.
 *
 * Keep this policy in source control so every deployment has the same safe defaults.
 * Environment variables are intentionally not used for required redaction rules: a
 * missing or stale deployment value must never make a previously safe route leak data.
 */

export const REDACTED_VALUE = '[Redacted]';
export const REDACTED_PATH_SEGMENT = '[redacted]';

export const SENSITIVE_DATA_KEY_PATTERN =
  /password|passcode|token|secret|authorization|cookie|csrf|session|api.?key|access.?key|private.?key|credential|email|phone|ssn|card.?number|cvv/i;

/**
 * Route templates whose dynamic segments contain credentials or other secrets.
 * A `:segment` is redacted; literal segments are used to match the route.
 *
 * Add new token-bearing frontend routes here as part of the route's implementation.
 * Query-string values do not need a route entry when their key matches
 * SENSITIVE_DATA_KEY_PATTERN.
 */
export const SENSITIVE_ROUTE_TEMPLATES = [
  '/set-password/:token',
  '/shared-hotspot/:accessToken',
  '/unit-tour/:token',
  '/confirm-email/:key',
  '/reset-password/:uid/:token',
] as const;

export const DIAGNOSTIC_LIMITS = {
  maxDepth: 5,
  maxObjectKeys: 50,
  maxArrayItems: 50,
  maxStringLength: 2_000,
} as const;
